<ng-container *transloco="let t; prefix: 'group-management.interested-parties'">
  <span class="inline-flex" [attr.title]="t('export-tooltip')">
    <app-button
      variant="secondary"
      size="sm"
      [disabled]="disabled()"
      [ariaDescribedBy]="tooltipId"
      data-testid="interested-parties-export"
      (clicked)="download()"
    >
      <span class="uppercase">{{ t('export-button') }}</span>
    </app-button>
  </span>
  <span [id]="tooltipId" class="sr-only">{{ t('export-tooltip') }}</span>
</ng-container>
